/* eslint-env browser */
import React from 'react';
import {Link} from 'gatsby';

import {PageProps, SupportedLanguage} from '../types';

import '../styles/header.css';

interface HeaderProps {
	lang: SupportedLanguage;
	title: string;
}

type Props = PageProps & HeaderProps;
function Header({title, lang}: Props) {
	const otherLang = lang === 'ar' ? 'en' : 'ar';
	const otherDir = lang === 'ar' ? 'ltr' : 'rtl';

	return (
		<header className="Header">
			<h3>
				<Link to={`/${lang}/`}>{title}</Link>
			</h3>

			<aside dir={otherDir} lang={otherLang}>
				<small>
					<Link
						hrefLang={otherLang}
						dir={otherDir}
						lang={otherLang}
						to={`/${otherLang}/`}
					>
						{lang === 'ar'
							? 'Read posts written in English'
							: `
                            اقرأ التدوينات العربية
                            `}
					</Link>
				</small>
			</aside>
		</header>
	);
}

export default Header;
